import React, { type FC } from 'react'
import { UiConditionType, UiTrackingConditionTypes } from '../filterConditionTypes'
import DeviceSpecCondition from './specs/DeviceSpecCondition'
import EngagementSpecCondition from './specs/EngagementSpecCondition'
import GeoSpecCondition from './specs/GeoSpecCondition'
import GroupSpecCondition from './specs/GroupSpecCondition'
import ActivityDateDetailsCondition from './specs/ActivityDateDetailsCondition'
import ActivityMessageCondition from './specs/ActivityMessageCondition'
import ActivityLinkCondition from './specs/ActivityLinkCondition'
import TrackingCondition from './specs/TrackingCondition'
import ProfileFieldCondition from './specs/ProfileFieldCondition'

interface ConditionFactoryProps {
  conditionType: UiConditionType
  blockIndex: number
  condIndex: number
}

const ConditionFactory: FC<ConditionFactoryProps> = ({
  conditionType,
  blockIndex,
  condIndex,
}) => {
    
  switch (conditionType) {
  
    case UiConditionType.GroupBelongs:
    case UiConditionType.GroupNotBelongs:
      return (
        <GroupSpecCondition blockIndex={blockIndex} condIndex={condIndex} />
      )
    case UiConditionType.ProfileField:
      return (
        <ProfileFieldCondition blockIndex={blockIndex} condIndex={condIndex} />
      )

    case UiConditionType.EmailSubscribed:
    case UiConditionType.EmailUnsubscribed:
      return (
        <ActivityDateDetailsCondition
          blockIndex={blockIndex}
          condIndex={condIndex}
        />
      )
    case UiConditionType.EmailSent:
    case UiConditionType.EmailSuccessfullySent:
    case UiConditionType.EmailNotSent:
    case UiConditionType.EmailOpened:
    case UiConditionType.EmailNotOpened:
    case UiConditionType.EmailBouncedHB:
    case UiConditionType.EmailBouncedSB:
    case UiConditionType.EmailNotBouncedHB:
    case UiConditionType.EmailPerformedAtLeast1Action:
    case UiConditionType.EmailPerformedLessThan5Actions:
    case UiConditionType.EmailPerformedLessThan10Actions:
    case UiConditionType.EmailPerformed10OrMoreActions:
    case UiConditionType.SmsSent:
    case UiConditionType.SmsNotSent:
    case UiConditionType.SmsSuccessfullySent:
    case UiConditionType.SmsNotReceived:
    case UiConditionType.SmsExpired:
    case UiConditionType.SmsRejected:
      return (
        <ActivityMessageCondition
          blockIndex={blockIndex}
          condIndex={condIndex}
        />
      )
    case UiConditionType.EmailClicked:
    case UiConditionType.EmailNotClicked:
      return (
        <ActivityLinkCondition blockIndex={blockIndex} condIndex={condIndex} />
      )

    case UiConditionType.Engagement:
      return (
        <EngagementSpecCondition
          blockIndex={blockIndex}
          condIndex={condIndex}
        />
      )

    case UiConditionType.GeoLocatedIn:
    case UiConditionType.GeoNotLocatedIn:
      return <GeoSpecCondition blockIndex={blockIndex} condIndex={condIndex} />

    case UiConditionType.Device:
      return (
        <DeviceSpecCondition blockIndex={blockIndex} condIndex={condIndex} />
      )

    case UiTrackingConditionTypes.TrackingActive:
    case UiTrackingConditionTypes.TrackingAnonymous:
      return (
        <TrackingCondition blockIndex={blockIndex} condIndex={condIndex} />
      )

    default:
      return <></>
  }
}
export default ConditionFactory
